import { render } from "./CreditReport.vue?vue&type=template&id=0671e486"
import script from "./CreditReport.vue?vue&type=script&lang=js"
export * from "./CreditReport.vue?vue&type=script&lang=js"

import "./CreditReport.vue?vue&type=style&index=0&id=0671e486&lang=css"

import exportComponent from "C:\\Users\\zhang\\Desktop\\loan\\loanweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__